import {useAppSelector} from '@/hooks';

export const useGetNumberOfPages = (): number => {
  return useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages.pageOrder.length ?? 0;
  });
};
